import { render, staticRenderFns } from "./ComboContasBanco.vue?vue&type=template&id=3621e743"
import script from "./ComboContasBanco.vue?vue&type=script&lang=js"
export * from "./ComboContasBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports